import { format } from 'date-fns';
import { isEmpty } from '../../utils';

const fmtDate = d => {
  try {
    return format(d instanceof Date ? d : new Date(d), 'yyyy-MM-dd');
  } catch {
    return undefined;
  }
};

const browserTz = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
};

/**
 * Build the `context` object for POST /v1/kai/ask (contract §2).
 *
 * - `business_id` is required.
 * - `branch_ids` / `brand_ids` come from the drawer's loaded scope for that
 *   business (all branches/brands). analyseit tools require at least one of
 *   these; admin Kong headers often omit them.
 * - When Native Analytics is scoped to the same business and has an explicit
 *   branch/brand selection, those filters narrow the ask (subset of drawer
 *   scope). `date_range` is taken from NA only in that same-business case.
 */
export const buildKaiContext = (state, businessId) => {
  const context = { business_id: businessId };

  let branchIds = state?.kai?.branchIds || [];
  let brandIds = state?.kai?.brandIds || [];

  const na = state?.nativeAnalytics;
  const naBusinessId = na?.selectedBusiness?.id;
  if (na && naBusinessId != null && naBusinessId === businessId) {
    const naBranchIds = (na.selectedBranch || [])
      .map(b => b?.id)
      .filter(id => id != null);
    if (!isEmpty(naBranchIds)) branchIds = naBranchIds;

    const naBrandIds = (na.selectedBrand || [])
      .map(b => b?.id)
      .filter(id => id != null);
    if (!isEmpty(naBrandIds)) brandIds = naBrandIds;

    const start = fmtDate(na.analyticsStartDate);
    const end = fmtDate(na.analyticsEndDate);
    if (start && end) context.date_range = { start, end };
  }

  if (!isEmpty(branchIds)) context.branch_ids = branchIds;
  if (!isEmpty(brandIds)) context.brand_ids = brandIds;

  const tz = browserTz();
  if (tz) context.tz = tz;

  return context;
};
